import { useAppQuery } from "~/hooks/useAppQuery"
import { getPrivacyPolicy } from "../server/privacy-policy.functions"

export const privacyPolicyQueryKey = ["profile", "privacy-policy"] as const

export function usePrivacyPolicy() {
  return useAppQuery({
    queryKey: privacyPolicyQueryKey,
    queryFn: () => getPrivacyPolicy(),
    errorMessage: "Не удалось загрузить политику конфиденциальности",
  })
}
